import clsx from "clsx";
import React, { FC, useState } from "react";
import AsyncSelect from "react-select/async";
import { useAPI } from "../../hooks/useAPI";
import { CalendarType } from "../../types/EventType";

interface Props {
    onChange: any;
    name: string;
    value?: any;
    placeholder?: string;
    isSearchable?: boolean;
    isValid?: boolean;
    isTouched?: boolean;
    disabled?: boolean;
    calendars?: CalendarType[];
}

const CalendarSelect: FC<Props> = (
    {
        onChange,
        value = undefined,
        placeholder = `Selecionar...`,
        isSearchable = false,
        isValid = false,
        isTouched = false,
        disabled = false,
        calendars = []
    }) => {

    const { api } = useAPI(); 

    const promiseOptions = (inputValue: string) => {        
        if (calendars.length > 0) {
            return new Promise<Array<any>>((resolve) => {
                resolve(
                    calendars
                        .filter((cal) => cal.name.toLowerCase().includes(inputValue.toLowerCase()) || inputValue === "")
                        .map((value: any) => {
                            return { "label": `${value.name}`, "value": value.id };
                        })
                );
            });
        }

        return new Promise<Array<any>>((resolve) => {
            api().get(`/api/calendars?search=${inputValue}`).then((resp) => {
                let options: Array<any> = [];
                resp.data.map((value: any) => {
                    options.push({ "label": `${value.name}`, "value": value.id });
                });
                resolve(options);
            });
        });
    };

    const getSelectedOption = (options: Array<any>, value: any) => {
        if (value === undefined || value === null) return undefined;
        for (let i in options) {
            if (options[i].value.toString() === value.toString()) {
                return options[i];
            }
        }
        return undefined;
    };

    const getDefaultOptions = () => {
        return calendars.map((value: any) => { return { "label": `${value.name}`, "value": value.id }; });
    }

    const [defaultValue, setDefaultValue] = useState(
        getSelectedOption(getDefaultOptions(), value)
    );

    return (
        <AsyncSelect
            defaultOptions={getDefaultOptions()}
            placeholder={placeholder}
            onChange={onChange}
            loadOptions={promiseOptions}
            loadingMessage={(inputValue: any) => "Carregando..."}
            noOptionsMessage={(inputValue: any) => "Sem resultados"}
            isDisabled={disabled}
            defaultValue={defaultValue}
            className={clsx("react-select-container", {
                "is-invalid": isTouched && !isValid,
                "is-valid": isTouched && isValid
            })}
            classNamePrefix={'react-select'}
            isSearchable={isSearchable}
            isClearable={false}
        />
    );
};

export default CalendarSelect;